import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type TopBarStyleKey =
  | 'topBar'
  | 'topBarR8tr'
  | 'topBarLogo'
  | 'navlink_list'
  | 'navlink_list2'
  | 'topBarContent'
  | 'titleCluster'
  | 'metricsCluster'
  | 'navIcon'
  | 'avatar'
  | 'signOut';

export const topBarStyles = {
  topBar: {
    marginLeft: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'rgb(var(--canvas))',
    color: 'rgb(var(--ink))',
    height: '64px',
  },
  topBarR8tr: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'rgb(var(--canvas))',
    color: 'rgb(var(--ink))',
    height: '64px',
  },
  topBarLogo: {
    height: '50px',
    width: '88px',
  },
  navlink_list: {
    display: { xs: 'none', sm: 'flex' },
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: { sm: '20px' },
    gap: 1,
  },
  navlink_list2: {
    display: { xs: 'flex', sm: 'none' },
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 6px',
  },
  topBarContent: {
    color: 'rgb(var(--muted))',
    display: { xs: 'flex', sm: 'none' },
  },
  titleCluster: {
    display: 'flex',
    minWidth: 0,
    flex: 1,
    alignItems: 'center',
  },
  metricsCluster: {
    mr: 1,
    display: { xs: 'none', lg: 'flex' },
    alignItems: 'center',
    gap: 1,
  },
  navIcon: {
    position: 'relative',
    display: 'flex',
    height: 40,
    width: 40,
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    color: 'rgb(var(--muted))',
    transition: 'background-color 0.2s ease, color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgb(var(--field))',
      color: 'rgb(var(--ink))',
    },
  },
  avatar: {
    height: 36,
    width: 36,
    cursor: 'pointer',
    backgroundColor: 'rgb(var(--line))',
    boxShadow: '0 0 0 2px rgb(var(--line))',
  },
  signOut: {
    height: 50,
    width: '100%',
    borderColor: 'rgb(var(--primary))',
    color: 'rgb(var(--primary))',
    fontWeight: 700,
    backgroundColor: 'transparent',
    transition: 'background-color 0.2s ease, color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgb(var(--primary) / 0.15)',
      borderColor: 'rgb(var(--primary))',
      color: 'rgb(var(--primary))',
    },
  },
} satisfies Record<TopBarStyleKey, SystemStyleObject<Theme>>;
